export const buildLoginPayload = ({ email, password, turnstileToken }) => ({
    email,
    password,
    ...(turnstileToken && { turnstile_token: turnstileToken }),
});

export const buildRpcLoginPayload = ({ username, password } = {}) => ({
    username,
    password,
});

export const buildForgotPasswordPayload = (email) => ({ Email: email });

export const buildResetPasswordPayload = ({ email, token, password }) => ({
    Email: email,
    password,
    token,
});
